
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";
import config from "@/config";
import { pageViewUnit } from "@/config";
import { deepClone } from "@/common/utils";
@Component({
  name: "HomeSearch",
  components: {},
})
export default class HomeSearch extends Vue {
  @Getter("company") private company!: string;
  @Getter("cityId") private cityId!: string;
  @Getter("cityName") private cityName!: string;
  @Getter("role") private role!: string;
  @Action("policy/searchPolicyData") private getMatchList: any;
  @Getter("id") private id!: any;
  @Action("policy/getSearchList") private getSearchList: any;
  @Action("policy/searchAllPolicy") private searchAllPolicy: any;
  @Action("getSearchList") private getAllSearchListData: any;
  pageViewUnit = pageViewUnit;
  isKunMing: any = config.isKunMing;
  private toMatch({ id }: any, column?: any, e?: any) {
    if (!id) {
      return;
    }
    this.$router.push({
      path: `/detail/match`,
      query: {
        id,
      },
    });
    // this.isDialog = true;
  }
  btnList: any = [
    // {
    // 	label: "速匹配",
    // 	placeholder: "请输入企业名称 进行政策匹配"
    // },
    {
      label: "找政策",
      placeholder: "请输入政策、项目、通知、公告标题进行搜索",
    },
  ];
  keyTitle: string = "热搜词";
  activeBtn: any = 0;
  restaurants = [];
  matchList: any = [];
  searchValue: any = "";
  searchText = "搜索";
  policyData: any = [];
  companyData: any = [];
  hotWord: Array<string> = [];
  enterpriseWord: any = [];
  policyWord: any = [];
  created() {
    this.searchValue = deepClone(this.$route.query.params);
    this.getData();
  }
  getData() {
    this.getHotWord();
    // this.getRecomData();
  }
  async getAllSearchList(search: any) {
    const options = {
      cityName: this.cityName,
      corporateName: search,
    };
    const res = await this.getAllSearchListData(options);
    return res;
  }
  getRecomData() {
    const unitList = ["unit", "declare"];
    const { cityId } = this.$root.$data.currentAreaProps;
    let options: any = {
      page: 1,
      size: 2,
      code: this.cityId,
      nature: "",
    };
    this.getMatchList(options)
      .then((res: any) => res.list)
      .then((list: any) => {
        this.matchList = list.map((item: any) => {
          if (item.labels.indexOf(",") >= 0) {
            item.labels = item.labels.split(",");
          } else {
            item.labels = item.labels.split("，");
          }
          return item;
        });
      })
      .catch((err: any) => err);
  }
  getHotWord() {
    this.getSearchList()
      .then((res: any) => {
        const { code, data, msg } = res;
        if (code === 0 && data) {
          const { policy } = data;
          this.policyWord = policy;
          this.enterpriseWord = [];
          // if (this.activeBtn === 0) {
          // 	this.hotWord = [];
          // } else {
          // 	this.hotWord = policy;
          // }
          this.hotWord = policy;
        }
      })
      .catch((err: any) => err);
  }
  getSearchWord() {
    this.$store.dispatch("policy/getSearchWord").then((data: any) => {
      if (data) {
        this.policyData = data.map((item: any) => {
          return { value: item };
        });
      }
    });
  }
  onclick(e: number) {
    this.activeBtn = e;
    this.searchValue = "";
    this.restaurants = this.policyData;
    this.searchText = "搜索";
    this.hotWord = this.policyWord;
    // if (e === 0) {
    // 	this.restaurants = this.companyData;
    // 	this.searchText = "匹配";
    // 	this.hotWord = this.enterpriseWord;
    // 	// this.getHotWord();
    // } else {
    // 	this.restaurants = this.policyData;
    // 	this.searchText = "搜索";
    // 	this.hotWord = this.policyWord;
    // }
  }
  async querySearch(queryString: any, cb: any) {
    // let restaurants: any = [];
    // if (queryString && this.activeBtn === 0) {
    // 	const originRestaurants = await this.getAllSearchList(queryString);
    // 	restaurants = originRestaurants;
    // 	this.restaurants = restaurants;
    // } else if (queryString && this.activeBtn === 1) {
    // 	const originRestaurants = await this.searchAllPolicy(queryString);
    // 	restaurants = originRestaurants.map((item: any) => {
    // 		return { value: item, id: item };
    // 	});
    // 	this.restaurants = restaurants;
    // }
    // const results = queryString
    // 	? restaurants.filter((item: any) => item.value.indexOf(queryString) >= 0)
    // 	: restaurants;
    // // 调用 callback 返回建议列表的数据
    // cb(results);
  }
  createFilter(queryString: any) {
    return (restaurant: any) => {
      return (
        restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0
      );
    };
  }
  search(type: any) {}
  searchData(word: any) {
    if (!this.searchValue && !word) {
      return this.$message.error("请填写搜索内容");
    }
    this.$emit("searchData", this.searchValue || word);
  }
  changePage(word: any) {
    // if (!this.searchValue && !word) {
    // 	return this.$message.error("请填写匹配内容");
    // }
    // let id;
    // const filterRes = this.restaurants.find((item: any) => {
    // 	return item.value === this.searchValue;
    // });
    // if(!filterRes) {
    //   return this.$message.warning("无法匹配该政策")
    // }
    // this.searchValue = word
    this.$router.push({
      path: this.isKunMing ? "/kunmingdetail/allpolicy" : "/pcm/allpolicy",
      query: { params: word },
    });
    // if (this.activeBtn === 0) {
    // 	// if(!this.id) {
    // 	//   this.$router.push({path: '/login'});
    // 	//   return this.$message.warning("请先登录!")
    // 	// }
    // 	const filterRes = this.restaurants.find((item: any) => {
    // 		return item.value === this.searchValue;
    // 	});
    // 	if (!filterRes) {
    // 		return this.$message.warning("无法匹配该企业");
    // 	}
    // 	this.$router.push({
    // 		path: this.isKunMing ? "/kunmingdetail/company" : "/pcm/company",
    // 		query: { params: this.searchValue || word }
    // 	});
    // } else if (this.activeBtn === 1) {
    // 	const filterRes = this.restaurants.find((item: any) => {
    // 		return item.value === this.searchValue;
    // 	});
    // 	// if(!filterRes) {
    // 	//   return this.$message.warning("无法匹配该政策")
    // 	// }
    // 	this.$router.push({
    // 		path: this.isKunMing ? "/kunmingdetail/allpolicy" : "/pcm/allpolicy",
    // 		query: { params: this.searchValue || word }
    // 	});
    // 	// id = this.policyData.find((item: any) => item.value === this.searchValue).id;
    // 	// if (id) {
    // 	//   this.$router.push({
    // 	//     path: "/user/keyword",
    // 	//     query: {search: id},
    // 	//   });
    // 	// } else {
    // 	//   return this.$message.error('请在选择后不要改动搜索信息')
    // 	// }
    // }
  }
  handleSelect() {}
  @Watch(`$route`)
  handleRoutechange({ path }: any, from: any) {
    // location.reload()
    this.searchValue = deepClone(this.$route.query.params);
  }
  @Watch("cityId")
  handleCityChange() {
    this.getRecomData();
  }
}
